export const getActualMonthForTerminalCalendar = (modalPosition) => {
    if (modalPosition > 730) { return 9; };
    if (modalPosition > 540) { return 5; };
    return 1;
};
